module.exports = __webpack_public_path__ + "media/bootstrap-icons/option-2f86235d.svg";